import { SearchFilter } from './Filter';

interface SearchFilterContainerProps {
  placeHolder?: string;
}

export function SearchFilterContainer({ placeHolder }: SearchFilterContainerProps) {
  return <SearchFilter placeHolder={placeHolder} />;
}
